import PageLoader from '../../components/shared/PageLoader';
import { loginRoute, dashboardRoute } from "../../utils/appRoutes";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { notifyError } from "../../helper/notify";
import { isGroupOnlyModule } from "../../helper/libs/is-group-only-module";
import { useCallback } from "react";
import { isCustomerSide } from "../../utils/accountSide";

const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const {
    isAuthenticated,
    role,
    side,
    modules,
    isLoading
  } = useSelector((state) => state.auth);

  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectPath, setRedirectPath] = useState("");

  // // Function to get first accessible module
  // const getFirstAccessibleModule = () => {
  //   console.log("🔍 Finding first accessible module for role:", role);
  //   console.log("📦 Available modules:", modules);

  //   if (!modules || modules.length === 0) {
  //     console.log("⚠️ No modules found, using fallback");
  //     if (role?.toLowerCase() === "sellvia") {
  //       return "/sellvia/dashboard";
  //     } else if (role?.toLowerCase() === "admin") {
  //       return "/admin/dashboard";
  //     }
  //     return "/dashboard";
  //   }

  //   // Sort modules by order (ascending)
  //   const sortedModules = [...modules].sort((a, b) => {
  //     const orderA = a.order !== undefined ? a.order : 999;
  //     const orderB = b.order !== undefined ? b.order : 999;
  //     return orderA - orderB;
  //   });

  //   console.log("📋 Sorted Modules by Order:", sortedModules.map(m => ({
  //     name: m.name,
  //     order: m.order,
  //     route: m.route_path
  //   })));

  //   // Find first module with valid route_path
  //   const firstModule = sortedModules.find(m => m.route_path);
    
  //   if (firstModule) {
  //     console.log("🎯 First Accessible Module:", firstModule.name, "at order:", firstModule.order);
  //     return firstModule.route_path;
  //   }

  //   // Fallback
  //   console.log("⚠️ No module with route_path found, using fallback");
  //   if (role?.toLowerCase() === "sellvia") {
  //     return "/sellvia/dashboard";
  //   } else if (role?.toLowerCase() === "admin") {
  //     return "/admin/dashboard";
  //   }
  //   return "/dashboard";
  // };

  const getFirstAccessibleModule = useCallback(() => {
  console.log("🔍 Finding first accessible module for role:", role);

  const roleLower = role?.toLowerCase();
  const isAdminLike = ["admin", "super-admin", "superadmin"].includes(roleLower);

  if (!modules || modules.length === 0) {
    return dashboardRoute(isAdminLike, modules);
  }

  const sortedModules = [...modules].sort((a, b) => {
    return (a.order ?? 999) - (b.order ?? 999);
  });

  // Skip group-only modules (sidebar headings with no page of their own).
  const firstModule = sortedModules.find(m => m.route_path && !isGroupOnlyModule(m, modules));

  return firstModule?.route_path || dashboardRoute(isAdminLike, modules);

}, [modules, role]);

  useEffect(() => {
    console.log('[LastPage] AdminProtectedRoute effect run — path:', location.pathname,
      'isLoading:', isLoading, 'isAuthenticated:', isAuthenticated, 'role:', role);

    if (isLoading) {
      console.log('[LastPage] AdminProtectedRoute: still isLoading, bailing out for now');
      return;
    }

    if (!isAuthenticated) {
      console.log('[LastPage] AdminProtectedRoute: not authenticated, will render <Navigate to="/admin">');
      setIsChecking(false);
      return;
    }

    const currentPath = location.pathname;

    // 1. STRICT CHECK: Only non-customer roles can access
    if (isCustomerSide({ side, role })) {
      notifyError("Access denied. This area is for Admin Side only.");
      setRedirectPath(dashboardRoute(false));
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    // 2. IMPORTANT: AGAR USER LOGIN PAGE SE AYA HAI, TO FIRST MODULE PAR REDIRECT KARO
    if (currentPath === loginRoute(true) || currentPath === `${loginRoute(true)}/`) {
      const firstModulePath = getFirstAccessibleModule();
      console.log("🔄 Login redirect to first module:", firstModulePath);
      setRedirectPath(firstModulePath);
      setShouldRedirect(true);
      setIsChecking(false);
      return;
    }

    // 3. ALLOW KARO AGAR CURRENT PATH VALID MODULE HAI
    const hasAccess = modules.some(module => {
      if (!module.route_path) return false;
      // A group-only module has no page — its placeholder URL is not a page.
      if (isGroupOnlyModule(module, modules)) return false;
      if (currentPath === module.route_path) return true;
      if (module.route_path !== "/" && currentPath.startsWith(module.route_path)) {
        return true;
      }
      return false;
    });

    console.log('[LastPage] AdminProtectedRoute: checking access for', currentPath,
      '— hasAccess =', hasAccess, '— modules route_paths =', modules.map(m => m.route_path));

    if (!hasAccess) {
      console.log("❌ No access to:", currentPath);
      notifyError("You don't have permission to access this page.");

      // Redirect to first accessible module
      const firstModulePath = getFirstAccessibleModule();
      console.log('[LastPage] AdminProtectedRoute: bouncing away from', currentPath, 'to', firstModulePath, '— this overrides any last-visited-page redirect!');
      setRedirectPath(firstModulePath);
      setShouldRedirect(true);
    }

    setIsChecking(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, role, side, modules, location.pathname, isLoading]);

  // Show loading while checking
  if (isLoading || isChecking) {
    return (
      <PageLoader fullScreen />
    );
  }

  // If not authenticated, redirect to admin login
  if (!isAuthenticated) {
    return <Navigate to={loginRoute(true)} state={{ from: location }} replace />;
  }

  // If should redirect, navigate
  if (shouldRedirect && redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  // Render the children if all checks pass
  return children;
};

export default AdminProtectedRoute;